module.exports = __webpack_public_path__ + "static/bg-start15or20-66d1b20a276e7075e303df8ec87640df.jpg";